import React, { useState } from 'react';
import { Global, css } from '@emotion/core';
import styled from '@emotion/styled';
import { reset, typography, breakpoints } from '../../utils/style';
import Header from '../Header/Header';
import FooterMain from '../FooterMain/Footer';
import Breadcrumbs from './Breadcrumbs';
import PopupWindow from './PopupWindow';
import { getAuthUserName } from '../Auth/Utils';
import StoreContext from './Context/StoreContext.js'
import ScrollAnimation from "../../icons/svg/ScrollAnimation"

const Content = styled('div')`
  display: flex;
  min-height: 100vh;
  flex-direction: column; 
  background-position: bottom right;
  &.inter-blocked, &.popup-blocked {
    position: relative;
    overflow: hidden;
    height: 100vh;
    
    #toFix {
      z-index: 0;
    }
  }
  &.bg-added {
    background: rgba(0, 0, 0, 0.55);
  }
  &.popup-blocked {
    .nav-wrap {
      position: static;
    }
    #app-header, .logo {
      z-index: 0;
    }
  }
  @media (max-width: ${breakpoints.md}) {
    position: relative;
  }
`;

const AllContent = styled('div')`
  flex-grow: 1;
`;

const Main = styled('main')`
  // margin-top: -50px;
  .with-overflow-slider { 
    overflow-x: hidden; 
  }
  .scroll-animation {
    position: fixed;
    bottom: 40px;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 200;
    animation: pulsing 3s infinite;
  }
  .mouse {
    animation: moveTop 3s infinite;
  }
  .arrow-down {
    animation: moveDown 3s infinite;
  }
  
  @keyframes pulsing {
    0% {
      transform: scale(1)
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
  
  @keyframes moveTop {
    0% {
      transform:translate(0);
    }
    50% {
      transform:translate(0, -8px);
    }
    100% {
      transform:translate(0);
    }
  }
  @keyframes moveDown {
    0% {
      transform:translate(0);
    }
    50% {
      transform:translate(0, 8px);
    }
    100% {
      transform:translate(0);
    }
  }
  @media (max-width: ${breakpoints.lg}) {
    .scroll-animation {
      display: none;
    }
  }
`;

const Layout = ({ children, breadcrumbs, page_title }) => {
  const [username, setUsername] = useState(getAuthUserName());
  return([
    <Global key="reset" styles={css`${reset} ${typography}`}/>,
    <StoreContext.Provider key="login-context-provider" value={{username: username, setUsernameCallback: setUsername}}>
      <Content key="app-content" id="all-content">
        <AllContent key="app-content-block">
          <Header key="app-header" id="app-header" location="/"/>
          <Main key="app-content-main">
            {page_title ? <Breadcrumbs breadcrumbs={breadcrumbs} page_title={page_title}/> : ''}
            {children}
            <ScrollAnimation/>
          </Main>
        </AllContent>
        <FooterMain key="app-footer"/>
        <PopupWindow key="popup-window" title="Popup window" />
      </Content>
    </StoreContext.Provider>
  ])
};

export default Layout;